// extracted by mini-css-extract-plugin
export default {"list":"XAbgb","item":"QSsVd","link":"ylpDR","label":"kllmL","icon":"P4gMM","itemSelected":"RhZ_h","caption":"sZ_e9","iconWithBackground":"CgrAF","matchesCount":"BNyPM"};